export default __webpack_public_path__ + "static/media/puzzlePieces.e58f90db.png";